import { ErrorPage } from './../pages/error/error';
import { SuccessfulPageModule } from './../pages/successful/successful.module';
import { SuccessfulPage } from './../pages/successful/successful';
import { MeetingAreasPage } from './../pages/meeting-areas/meeting-areas';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpClientModule } from '@angular/common/http';


import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { EczaneService } from '../_services/eczane.service';
import { LaunchNavigator } from '@ionic-native/launch-navigator';
import { LocationPageModule } from '../pages/location/location.module';
import { MeetingAreasService } from '../_services/meeting-areas.service';
import { MeetingAreasPageModule } from '../pages/meeting-areas/meeting-areas.module';
import { ComponentsModule } from '../components/components.module';
import { Geolocation } from '@ionic-native/geolocation';
import { ErrorPageModule } from '../pages/error/error.module';

@NgModule({
  declarations: [
    MyApp,
    HomePage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {}, {
      links: [
        { component: HomePage, name: 'Home', segment: 'eczaneler' },
        { component: MeetingAreasPage, name: 'MeetingAreas', segment: 'toplanma-alanlari' },
        { component: SuccessfulPage, name: 'Successful', segment: 'successful' },
        { component: ErrorPage, name: 'Error', segment: 'error' }
      ]
    }),
    LocationPageModule,
    MeetingAreasPageModule,
    SuccessfulPageModule,
    ErrorPageModule,
    ComponentsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    MeetingAreasPage,
    ErrorPage,
    SuccessfulPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    EczaneService,
    MeetingAreasService,
    LaunchNavigator,
    Geolocation,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts